/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

//const baseUrl = 'http://alpha-03.trizentinc.com:40080/empats/uat';
// const baseUrl = 'https://alpha-03.trizentinc.com/empats/uat';
const baseUrl =
  (window as any)?.API_BASE_URL ||
  `https://api.empats-uat.alpha-03.trizentinc.com`;

export default baseUrl;
